// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerDocument = `
    mutation createDesignStudioProductAndAddToCartWeddingRingExistingCustomer($input: DesignStudioWeddingRingInput!) {
  createDesignStudioProductAndAddToCartWeddingRingExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useCreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutation, SchemaTypes.CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutationVariables>(CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerDocument);
};